import i18n from './config'

const normalizeInterpolationPlaceholders = (text) => {
  if (typeof text !== 'string') {
    return text
  }

  // Compat layer:
  // Converts i18n keys like "Passo {step}" into "Passo {{step}}"
  // while preserving keys that already use "{{step}}".
  return text.replace(/(^|[^{}])\{\s*([A-Za-z0-9_]+)\s*\}(?!\})/g, '$1{{$2}}')
}

const interpolateTemplate = (template, params) => {
  if (typeof template !== 'string') {
    return template
  }

  const normalizedTemplate = normalizeInterpolationPlaceholders(template)
  const interpolator = i18n?.services?.interpolator

  if (!interpolator) {
    return normalizedTemplate
  }

  return interpolator.interpolate(normalizedTemplate, params, i18n.language)
}

export const _t = (text, params) => {
  const hasParams = params && typeof params === 'object' && !Array.isArray(params) && Object.keys(params).length > 0

  if (!hasParams) {
    return i18n.t(text, params)
  }

  const normalized = normalizeInterpolationPlaceholders(text)

  const candidateKeys = normalized !== text ? [normalized, text] : [text]

  for (const key of candidateKeys) {
    if (i18n.exists(key)) {
      const translated = i18n.t(key, params)
      return interpolateTemplate(translated, params)
    }
  }

  const fallback = i18n.t(normalized, params)
  return interpolateTemplate(fallback, params)
}

export const _ = (strings, ...values) => {
  if (typeof strings === 'string') {
    return _t(strings)
  }

  const text = strings.reduce((acc, part, index) => {
    const value = index < values.length ? values[index] : ''
    return acc + part + value
  }, '')

  return _t(text)
}

export default _t
